import { aktiveKanaele, kanalPfad, MARKETING_RUBRIKEN, type MarketingRoute } from '@portal/contracts';

/**
 * #870 Marketing-Menüstruktur: reine Hilfsfunktionen für Rubrik-Navigation, Kanal-Seitennavigation und Breadcrumb —
 * getestet ohne DOM. Rechte prüft die API/Cerbos; die Oberfläche blendet nur aus.
 */
export interface NavEintrag {
  label: string;
  path: string;
  aktiv: boolean;
}

/** Rubrik-Navigation (Übersicht · Veröffentlichung · Produktion); aktiv = Rubrik der aktuellen Route */
export function rubrikNav(route: MarketingRoute): NavEintrag[] {
  return MARKETING_RUBRIKEN.map((r) => ({ label: r.label, path: r.path, aktiv: r.key === route.rubrik }));
}

/** Kanal-Seitennavigation einer Rubrik; erster Eintrag = Rubrik-Übersicht */
export function kanalNav(rubrik: 'veroeffentlichung' | 'produktion', aktiverSlug: string | null): NavEintrag[] {
  const r = MARKETING_RUBRIKEN.find((x) => x.key === rubrik)!;
  return [
    { label: 'Übersicht', path: r.path, aktiv: aktiverSlug === null },
    ...aktiveKanaele().map((k) => ({ label: k.name, path: kanalPfad(rubrik, k.slug), aktiv: k.slug === aktiverSlug })),
  ];
}

/** Breadcrumb Marketing › Rubrik › Kanal; letzter Eintrag ohne Pfad (aktuelle Seite) */
export function breadcrumb(route: MarketingRoute): { label: string; path: string | null }[] {
  const r = MARKETING_RUBRIKEN.find((x) => x.key === route.rubrik)!;
  const kette: { label: string; path: string | null }[] = [{ label: 'Marketing', path: '/marketing' }];
  if (route.rubrik !== 'uebersicht') kette.push({ label: r.label, path: r.path });
  if (route.kanal) kette.push({ label: route.kanal.name, path: null });
  kette[kette.length - 1]!.path = null;
  return kette;
}


export const LEER_TEXT = 'Noch keine Inhalte.';
export const BERECHTIGTE_TITEL = 'Berechtigte Personen und Agenten';
export const BERECHTIGTE_LEER = 'Noch niemand berechtigt.';
/** Platzhalter-Kennzahlen je Kanal-Kachel (Inhalt folgt) */
export const KACHEL_KENNZAHLEN = {
  veroeffentlichung: ['Geplant', 'Veröffentlicht', 'Reichweite'],
  produktion: ['In Arbeit', 'Bereitgestellt', 'Lieferanten'],
} as const;
